import type {
  TemperatureEntity,
  TemperaturePropsPub,
  TemperaturePropsPvt,
} from './entity/temperatureEntity';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { TemperatureJsonPub, TemperatureJsonPvt } from '@/types/domain/temperature/entities/temperatureEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 体温ドメインサービス(施設)
 */
export class TemperatureNurseryDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * sendNurseryTemperature
   * @param entity entity
   */
  async sendNurseryTemperature(
    entity: TemperatureEntity,
  ) {
    await this.wagakoNurseryApi.send<
      TemperaturePropsPvt,
      TemperatureJsonPvt,
      TemperaturePropsPub,
      TemperatureJsonPub
    >(entity);
  }

  /**
   * removeNurseryTemperature
   * @param entity entity
   */
  async removeNurseryTemperature(
    entity: TemperatureEntity,
  ) {
    await this.wagakoNurseryApi.remove<
      TemperaturePropsPvt,
      TemperatureJsonPvt,
      TemperaturePropsPub,
      TemperatureJsonPub
    >(entity);
  }
}
